<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" />
			<span>课程简介</span><i class="el-icon-arrow-right"></i>&nbsp;<span>课程简介</span>
		</div>
		<div class="content">
			<div class="info-content info-content-nobor">
				<div class="clearfix">
					<div class="zy_course_infos">
						<img src="@/images/couseinfos.png" class="zy_course_infoback" />
						<div class="zy_course_infocont">
							<div class="zy_course_infoP1 text-ellipsis">
								{{course.name}}
							</div>
							<div class="zy_course_infoP2 text-ellipsis">
								<span>{{course.username}}</span>
								<span>时长：{{course.duration | tofixTime}}</span>
								<span>学习人数：{{addCount() || '0'}} 人</span>
							</div>
							<div class="zy_course_infoP3" @click="toCoursedetailsFile(lastsection)">
								开始学习
							</div>
						</div>
						<div class="zy_course_infodesc">
							<div class="zy_course_infodescimg">
								<img :src="baseurl + course.banner" v-if="course.banner" />
							</div>
							<div class="zy_course_infodescP1">课程介绍</div>
							<div class="zy_course_infodescP2" v-html="getInfoText(course.info)"></div>
						</div>
					</div>
					<div class="zy_course_studys zy_course_studysbig">
						<div class="course_info_menu ">
							<img src="@/images/courseinfotop.png" class="course_info_menuback" />
							<div class="course_info_menus clearfix">
								<div class="course_info_menuitem" :class="showindex==1?'active':''" @click="showindex = 1">
									<img src="@/images/coursenav.png" />
									<span>课程章节</span>
								</div>
							</div>
						</div>
						<div class="course-info-main clearfix  minheight600">
							<div class="clearfix" v-show="showindex==1">
								<div class="course-description zy_course_wrap">
									<el-collapse v-model="activeNames">
										<el-collapse-item title="课程概述" name="1">
											<div v-html="course.overview" class="course_overview"></div>
										</el-collapse-item>
										<el-collapse-item title="参考资料：" name="2">
											<div v-html="getInfoText(course.references)"></div>
										</el-collapse-item>
									</el-collapse>
								</div>
								<div class="course-chapters">
									<div class="chapter zy_course_wrap treeBoxStu">
										<el-tree :data="courseTree" :default-expand-all='true' :expand-on-click-node='false' node-key="courseDetailId" :props="defaultProps" @node-click='handleNodeClickStu' ref='courseStudentTree'>
											<div class="custom-tree-node" slot-scope="{ node, data }">
												<div class="asideInfoLabel">
													{{data.courseDetailName}}
													<div class="asideInfoitem" v-if="data.parentId!='0'">
														<button v-if='data.over == undefined' class="r moco-btn moco-btn-red preview-btn">开始学习</button>
														<span v-if='data.over == 0' class="studyclose r">最近学习</span>
														<span v-if='data.over == 1' class="studyclose r"><i class="el-icon-success"></i> 已经学习 </span>
													</div>
												</div>
											</div>
										</el-tree>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { selectCourseDetail, appCourseTree } from '@/api/course.js'
	import { getStorageToken } from '@/utils/auth'
	export default {
		name: 'courseindexpublic',
		data() {
			return {
				activeNames: ['1', '2'],
				courseId: '',
				courses: [''],
				course: {},
				courseTree: [],
				lastsection: '',
				showindex: 1,
				defaultProps: {
					id: 'courseDetailId',
					children: 'childrenList',
					label: 'courseDetailName'
				},
			}
		},
		created() {
			var courseId = this.$route.query.id;
			if(courseId) {
				this.courseId = courseId;
				var token = getStorageToken();
				if(token) {
					this.$router.push({
						name: 'courseindex',
						query: {
							id: courseId
						}
					})
				} else {
					this.getCourseinfo();
					this.getCourseList();
				}
			}
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			addCount(){
				var item = this.course;
				var signCount =0
				if(item.signCount && !Number.isNaN(signCount)){
					signCount = item.signCount*1
				}
				var addNumber = 800;
				if(item.name == '针灸学' || item.name == '推拿学'){
					addNumber = 2000;
				}else if(item.name == '传统养生功法' || item.name == '保健按摩'){
					addNumber = 900;
				}else if(item.name == '推拿手法' || item.name == '足反射疗法'){
					addNumber = 1000;
				}
				return signCount+addNumber
			},
			getInfoText(strOld) {
				var strNew = ''
				if(strOld) {
					strNew = strOld.replace(/[\r\n]/g, "<br/>");
				}
				return strNew
			},
			getCourseinfo() {
				var data = {
					courseId: this.courseId
				}
				appCourseTree(data).then(res => {
					if(res.code == 0) {
						this.courses = res.data;
						this.course = res.data[0];
						var documentfile = this.courses[0].document;
						if(documentfile) {
							documentfile = JSON.parse(documentfile);
							this.courses[0].document = documentfile
						}
					}
				})
			},
			getCourseList() {
				var data = {
					courseId: this.courseId
				}
				selectCourseDetail(data).then(res => {
					if(res.code == 0) {
						this.courseTree = res.data
					}
				})
			},
			isShow(file) {
				if(file.type == '0' || file.type == '1' || file.type == '5') {
					return true;
				} else if(file.isConversion == '1') {
					return true;
				} else {
					return false;
				}
			},
			toCoursedetailsFile(sectionId) {
				this.$router.push({
					name: 'coursedetailpublic',
					query: {
						courseId: this.courseId,
						sectionId: sectionId,
					}
				})
			},
			handleNodeClickStu(data) {
				if(data.parentId == '0') {
					return
				}
				this.$refs.courseStudentTree.setCurrentKey(data.courseDetailId);
				this.toCoursedetailsFile(data.courseDetailId)
			},
		},
	}
</script>